// 开发环境域名
const host_development = 'https://uz.oncenet.cn' //admin yz00112233

export default {
  // 版本
  version: '3.1.0',
  baseURL: process.env.NODE_ENV == 'production' ? '' : host_development,
  tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
